import { partyDeleteApi } from "../../api/party/partyDeleteApi"

export async function partyDeleteService(payload: { id: string }, token: string) {
	return await partyDeleteApi(payload, token)
}
